module.exports = __webpack_public_path__ + "img/venue-back.f50aa0bb.jpg";